<aside class="vd-panel">
    <div class="vd-panel-tabs" role="tablist" *ngIf="showComments">
        <button type="button" role="tab" [attr.aria-selected]="tab === 'next'" [class.is-active]="tab === 'next'" (click)="select('next')">
            Up next
        </button>
        <button type="button" role="tab" [attr.aria-selected]="tab === 'comments'" [class.is-active]="tab === 'comments'" (click)="select('comments')">
            Comments <span *ngIf="commentCount">{{ commentCount }}</span>
        </button>
    </div>
    <div class="vd-panel-title" *ngIf="!showComments">Videos in this album</div>
    <div class="vd-panel-body" role="tabpanel" [hidden]="showComments && tab !== 'next'">
        <ng-content select="[panelNext]"></ng-content>
    </div>
    <div class="vd-panel-body" role="tabpanel" *ngIf="showComments" [hidden]="tab !== 'comments'">
        <ng-content select="[panelComments]"></ng-content>
    </div>
</aside>
